import { fetchCountries as fetchCountriesFromApi } from '@/api/web'
import { objectHasKeys, isNullOrUndefined } from '@/utils/comparators'
import { thirtyDaysPolicyHasExpired } from '@/utils/cachePolicies'
/**
* Forces an API fetch of country information bypassing local storage.
* * @param {string} locale
*/
const fetchCountries = async ({ commit }, locale) => {
  commit('SET_COUNTRIES_LOADING', true)

  try {
    let response = await fetchCountriesFromApi(locale)
    commit('SET_COUNTRIES', response)
  } catch (error) {
    console.error(error)
  }
  commit('SET_COUNTRIES_LOADING', false)
}

/**
* Load country information used by search functions.
* Get data from local storage or fetch from API if stale. Data is cached for 30 days.
* @param {string} locale
*/
const loadCountries = async ({ dispatch, state, commit }, locale) => {
  if (!state.forceLoadedCounties) {
    await dispatch('fetchCountries', locale)
    commit('SET_FORCE_LOADED_COUNTRIES', true)
  } else if (!state.countriesLoading && (thirtyDaysPolicyHasExpired(state.countriesCreated) || !objectHasKeys(state.countries))) {
    await dispatch('fetchCountries', locale)
  }
}

/**
 * Sets the application global loading state.
 * @param {boolean} status
 */
const setLoading = ({commit, state}, status) => {
  const defaultLoading = false
  if (state.loadingDisabled) return

  if (isNullOrUndefined(status) || typeof status !== 'boolean') {
    commit('SET_LOADING', defaultLoading)
    return
  }

  commit('SET_LOADING', status)
}

/**
* Disables the application global loading state.
*/
const disableLoading = ({commit}) => {
  commit('DISABLE_LOADING')
}

/**
* Disables the application global loading state.
*/
const enableLoading = ({commit}) => {
  commit('ENABLE_LOADING')
}

export default {
  fetchCountries,
  loadCountries,
  setLoading,
  disableLoading,
  enableLoading
}



// WEBPACK FOOTER //
// ./src/store/modules/app/actions.js